exports.number_format = function number_format(
  number,
  decimals,
  dec_point,
  thousands_sep
) {
  // Strip all characters but numerical ones.
  number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
};

exports.isEmpty = function isEmpty(input) {
  if (typeof input === "array") {
    return input.length === 0;
  }

  return !input || Object.keys(input).length === 0;
};

exports.printf = function printf(str, obj) {
  return str.replace(/\${(.*?)}/g, (x, g) => obj[g]);
};

exports.object_filter = function (obj, predicate) {
  let result = {},
    key;

  for (key in obj) {
    if (obj.hasOwnProperty(key) && !predicate(obj[key])) {
      result[key] = obj[key];
    }
  }

  return result;
};

exports.isObject = function (value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
};

exports.createDataTree = (dataset, idKey, parentKey) => {
  const hashTable = Object.create(null);
  dataset.forEach(
    (aData) => (hashTable[aData[idKey]] = { ...aData, childNodes: [] })
  );
  const dataTree = [];
  dataset.forEach((aData) => {
    if (aData[parentKey])
      hashTable[aData[parentKey]].childNodes.push(hashTable[aData[idKey]]);
    else dataTree.push(hashTable[aData[idKey]]);
  });
  return dataTree;
};

exports.treeSort = function (array, sortBy) {
  const sorted = array.sort((a, b) => a[sortBy] - b[sortBy]);
  sorted.forEach((data) => {
    if (data.childNodes && data.childNodes.length) {
      data.childNodes = exports.treeSort(data.childNodes, sortBy);
    } else {
      return data.childNodes;
    }
  });
  return sorted;
};
